import React from 'react';

export default class BlankStoriesList extends React.Component
{
    render()
    {
        return <svg {...this.props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 217 121" fill="none" fillRule="evenodd" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
            <path d="M113 111c10 6 23 2 34-1 21-7 42-21 54-41 7-13 13-51 3-63-2-2-2 10-6 9-7-1 7-14 8-13l10 20M12 64c-30 18 9 43 14 11M35 80c-9-6-9-7 0-12M43 70c7-10-2-7-4-2-5 14 10 2 11 1M54 58c-12 14 8 11 5 1l-2-1 5 7M55 43c13 14 14 23 23 8M60 54l8-8M78 45c4-3 5-9 3-7-7 5-4 18 5 5" />
            <path d="M105 20c-13 10 4 12 4 2 0-1-3-4-1-3l6 6" />
            <path d="M80 69c-17 14-3 7 6 8 11 2-6 10-8 10M85 66c7 7 11 15 13 4M87 75l6-7M100 61c0 1 0 14 7 3 2-3-4-13-8 1M108 54c17 9 0 4 6-5M118 47l7 3c0-1-5-35 9 3 1 3-2 6-4 7h-7" />
            <path d="M25 113c14 20-16-19 13 2M42 110l6-6c1-2-5-10-8 2-2 10 10 6 12 0M49 97c1 2 6 10 9 2 0-1-3-4-1-4 1-1 1 3 3 4 6 1 6-8 3-10-2-2-6-2-9-3" />
        </svg>;
    }
}
